import script from "./OrderCardItemDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderCardItemDetails.vue?vue&type=script&lang=ts&setup=true"

import "./OrderCardItemDetails.vue?vue&type=style&index=0&id=44d8b01e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d8b01e"]])

export default __exports__